import { Component, Mixins } from "vue-property-decorator";
import GeographicArea from "@/mixins/http/GeographicArea";
import store from "@/store";

@Component
class GeographicAreasService extends Mixins(GeographicArea) {
  created() {
    this.$store = store;
  }
}

export default new GeographicAreasService();
